import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { jsx as _jsx } from "react/jsx-runtime";
import { Controller, useFormContext } from 'react-hook-form';
import { getRequiredValidator } from 'validators';
import { TextField } from 'seagull';
import { useLocaleKeys } from '~/i18n';
import { connectControllerToTextField, rhfValidateToBottomSheet } from '~/utils/react-hook-form.utils';
export default function UnitNameTextField(param) {
    let { testId } = param;
    const { control } = useFormContext();
    const { t: unitNameTexts } = useLocaleKeys('billing.unitName');
    const validate = getRequiredValidator(unitNameTexts.validation.required());
    return /*#__PURE__*/ _jsx(Controller, {
        control: control,
        name: "unitName",
        rules: {
            validate: {
                required: validate
            }
        },
        render: (renderProps)=>/*#__PURE__*/ _jsx(TextField, _object_spread({
                mobile: {
                    renderAsCard: true
                },
                bi: {
                    name: 'unit_name'
                },
                alwaysShrinkLabel: true,
                label: unitNameTexts.label(),
                testId: testId,
                validateInBottomSheet: rhfValidateToBottomSheet(validate)
            }, connectControllerToTextField(renderProps)))
    });
}
